/** React imports */
import { useTranslation } from "react-i18next";

/** MUI imports */
import {
    Grid,
    Checkbox,
    ListItemText,
    MenuItem,
} from "@mui/material";

/** Js imports **/
import CustomFilledSelectCountries from "../ui/CustomFilledSelectCountries";
import businessActivity from "../Js/businessActivity";
import CustTextField from "../ui/CustTextField";
import BaseSelect2 from "../ui/BaseSelect2";

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            boxShadow: "10px 10px 15px 0px rgba(3,24,81,0.15)",
        },
        sx: {
            borderRadius: 2,
            mt: 0.7,
        },
    },
    variant: "menu",
    getcontentanchorel: null,
};

const AddCompanyStep1 = (props) => {
    const [t] = useTranslation("global");

    const { isError, smbInfo, handleChange, systemsList, handleChangeCompanyName, isErrorName } = props;

    let bussinessActFinal = []

    for (let i = 0; i < businessActivity.length; i++) {
        bussinessActFinal.push({
            id: businessActivity[i].id,
            name: t("dialog." + businessActivity[i].translation)
        })
    }

    return (
        <Grid container sx={{ mt: 3 }} spacing={2}>
            <Grid item xs={12} md={6}>
                <CustTextField
                    fullWidth
                    label={t("dialog.companyName")}
                    name="companyName"
                    required
                    onChange={handleChangeCompanyName}
                    value={smbInfo.companyName}
                    inputProps={{
                        fontStyle: "normal",
                    }}
                    error={(isError && smbInfo.companyName.trim() === "") || isErrorName}
                    helperText={isErrorName && t("dialog.alreadyExists")}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <CustomFilledSelectCountries
                    required={true}
                    error={isError && !smbInfo.country}
                    label={t("register.country")}
                    value={smbInfo.country}
                    onChange={handleChange}
                    name="country"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <BaseSelect2
                    error={isError && !smbInfo.ecActivity}
                    required
                    label={t("dialog.ecActivity")}
                    value={smbInfo.ecActivity}
                    onChange={handleChange}
                    name="ecActivity"
                    values={bussinessActFinal}
                    idName="id"
                    valueName="name"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <BaseSelect2
                    error={isError && !smbInfo.systems.length}
                    fullWidth
                    id="demo-multiple-checkbox"
                    label={t("dialog.usedFormats")}
                    labelId="demo-multiple-checkbox-label"
                    MenuProps={MenuProps}
                    multiple
                    name="systems"
                    onChange={handleChange}
                    renderValue={(selected) => selected.join(", ")}
                    required
                    value={smbInfo.systems}
                >
                    {systemsList.map((item) => (
                        <MenuItem key={item} value={item}>
                            <Checkbox checked={smbInfo.systems.indexOf(item) > -1} />
                            <ListItemText primary={item} />
                        </MenuItem>
                    ))}
                </BaseSelect2>
            </Grid>
        </Grid>
    );
};

export default AddCompanyStep1;
